import { getIdDomainPrefix, getTripPlannerDomainPrefix, getApiDomainPrefix } from '../../UM-Base/lib/OidcHelper';

export const TripPlannerMode = {
  empty: '',
  login: 'login',
  sandbox: 'sandbox',
}

export function getIdServerUrl() {
  // get ID server URL for iframe src attribute
  const addTest = getIdDomainPrefix();
  return `https://id${addTest}.southaustralia.com`;
}

export function getTripPlannerUrl() {
  // get tripplanner URL for iframe src attribute
  const addTest = getTripPlannerDomainPrefix();
  return `https://trip${addTest}.southaustralia.com`;
}

export function getApiServerUrl() {
  // get tripplanner URL for iframe src attribute
  const addTest = getApiDomainPrefix();
  return `https://api${addTest}.southaustralia.com`;
}

// For Travel Mate Pre-deploy during development phase
export function isPredeployTm() {
  const hostname = window.location.host;
  return hostname.includes('predeploy-tm');
}

//--------------------------------------------------------------------------------
//  Sandbox mode
//  ------------
//  Sandbox mode is a way to test the Trip Planner without logging in.
//--------------------------------------------------------------------------------

export function isMode(checkMode) {
  // Check what mode we are in
  const tpMode = localStorage.getItem('tpMode');
  if(!tpMode) {
    // console.log('No mode set');
    showMessageboxModal('#msgboxModalModes');
    return checkMode === '';
  }
  if(tpMode === TripPlannerMode.sandbox) {
    return checkMode === TripPlannerMode.sandbox;
  }
  if(tpMode === TripPlannerMode.login) {
    // console.log('Login mode is set');
    return checkMode === TripPlannerMode.login;
  }

  return false;
}

export function showMessageboxModal(element) {
  console.log(`showMessageboxModal`);
  $(element).css("display", "block").addClass('show');
  $('.modal-iframe__backdrop').css("display", "block");  // greyout background
  $('#modal-messagebox-spinner').hide();
}

export function hideMessageboxModal(element) {
  $(element).css("display", "none").removeClass('show');
  $('.modal-iframe__backdrop').css("display", "none");
}

function showMessageboxModalSpinner() {
  showMessageboxModal('#msgboxModal');
  $('#msgbox-modal-container').addClass('modal-messagebox__spinner-container');
  $('#modal-messagebox-spinner').show();
  $('#modal-mode-messagebox').hide();
}

function hideMessageboxModalSpinner() {
  hideMessageboxModal();
  $('#msgbox-modal-container').removeClass('modal-messagebox__spinner-container');
  $('#modal-messagebox-spinner').hide();
  $('#modal-mode-messagebox').show();
}

export async function askForItineraries() {
  let count = 0;
  window.usersTrips = [];

  showMessageboxModalSpinner();

  // Send message to the iframe to get the itineraries
  await hasIframeLoaded();

  console.log('3');
  const message = {code: 'get_local_itinerary'};
  await postMessageToIframe(message);

  // Wait for the iframe to send the itineraries back
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      count++;
      if(window.usersTrips.length > 0 || count <= 100) {
        hideMessageboxModalSpinner();
        clearInterval(interval);
        resolve();
      }
    }, 100);
  });
}

async function hasIframeLoaded() {
  const iframe = $('#trip-frame');
  const iframeContainer = $('#trip-modal');
  const iframeUrl = getTripPlannerUrl();

  if (!iframe) return [];

  //Set the iframe source if required and hides it
  if (!iframe.attr('src') && iframeUrl && iframeContainer) {
    iframe.attr('src',iframeUrl + '/trip-sandbox');
    iframeContainer.hide();
  }
  else {
    return [];
  }

  // Wait for the iframe to load
  return new Promise((resolve, reject) => {
    iframe.on("load", () => {
      resolve();
    })
  });
}

async function postMessageToIframe(message) {
  const iframe = document.getElementById('trip-frame');
  const iframeUrl = getTripPlannerUrl();

  if (iframe.contentWindow) {
    iframe.contentWindow.postMessage(message, iframeUrl);
  }
}

// receive & filter messages from iframe
export async function receiveMessageListener(event) {
  if(getTripPlannerUrl() !== event.origin || typeof(event.data) === 'string')
    return;

  if(event.data.code === 'ack_get_local_itinerary') {
    console.log(`receiveMessage event origin: ${event.origin}`, event.data);
    window.usersTrips = convertTripToDrawModal(event.data.itinerary);
  }
}

function convertTripToDrawModal(trips) {
  if(!trips || trips.length === 0) return [];

  let imageUrls = [];
  let dayCount = 0;
  let stopCount = 0;
  const trip = trips[0];
  const id = trip.id;
  const title = trip.title;

  if (trip && trip.days && trip.days.length > 0) {
    dayCount = trip.days.length;

    if(trip.days[0].products && trip.days[0].products.length > 0) {
      imageUrls = trip.days[0].products.map((product) => product.image);
      stopCount = trip.days.map(i => i.products.length).reduce((a, b) => a + b);
    }
  }

  const tripObject = {
    id: id,
    name: title,
    dayCount: dayCount,
    stopCount: stopCount,
    imageUrl: imageUrls,
  }
  let tripArray = [];
  tripArray.push(tripObject);

  return tripArray;
}

export function isSandboxMode() {
  return localStorage.getItem('tpMode') === TripPlannerMode.sandbox;
}

export async function messageBoxAnswerWait() {
  // Wait for the iframe to get messagebox answer
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      const tpMode = localStorage.getItem('tpMode');
      // If its hidden or has a mode set, then we can continue
      if(tpMode || $('#msgboxModal').css("display") === "none") {
        clearInterval(interval);
        resolve(tpMode);
      }
    }, 200);
  });
}
